package com.example.hukakmp

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize

fun initializeWebFirebase() {
    if (Firebase.apps().isNotEmpty()) return

    Firebase.initialize(
        options = FirebaseOptions(
            applicationId = "1:976766461144:android:452e2e0af7fea324a1e3ad",
            apiKey = "AIzaSyB3r0-gFEZE29ipb2nUZmI4FSW23sxtABQ",
            projectId = "pesca-huka",
            storageBucket = "pesca-huka.firebasestorage.app",
            gcmSenderId = "976766461144",
            authDomain = "pesca-huka.firebaseapp.com",
        ),
    )
}
